import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';

import { Form } from '../../shared/form';
import { HttpErrorHandler } from '../../shared/http-error-handler';
import { ChoicesModel } from '../../_models/choices-model';

import { Effort } from '../../_models/effort';
import { Ship } from '../../_models/ship';

import { EffortService } from '../../_services/effort.service';
import { ShipService } from '../../_services/ship.service';

@Component({
  selector: 'app-effort-form',
  templateUrl: './effort-form.component.html',
  styleUrls: ['./effort-form.component.sass'],
})
export class EffortFormComponent extends Form implements OnInit {
  // Component attributes
  form: FormGroup;
  effort: Effort;
  ships: Ship[] = [];
  year = new Date().getFullYear();

  protected selectedShip: Ship = new Ship();
  protected selectedShips: Ship[] = [];

  constructor(
    private fb: FormBuilder,
    private effortService: EffortService,
    private shipService: ShipService,
    protected route: ActivatedRoute,
    protected router: Router,
    protected httpErrorHandler: HttpErrorHandler
  ) {
    super(route, httpErrorHandler);
    this.form = fb.group({
      year: '',
      name: '',
      ships: '',
      amount_shore: 0,
      amount_deep: 0,
    });
  }

  ngOnInit() {
    this.effort = new Effort({ year: this.year });
    this.getShips();
    this.setFormMode('create');
  }

  getShips() {
    this.shipService.list(1, 10000, '', '').subscribe(
      (response) => {
        this.ships = this.parseDropdownResults(response.results, new Ship(), 'name', true);
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }

  handleError(error) {
    const errors = this.httpErrorHandler.handleHttpError(error);
    this.parseApiErrors(errors, this.form);
  }

  onSubmit() {
    this.form.reset();
    this.resetNonFieldErrors();
    this.createEffort();
  }

  createEffort() {
    this.effort.ship = this.selectedShip;
    this.effort.ship_id = this.effort.ship.id;
    this.effortService.create(this.effort).subscribe(
      (effort) => this.onCreate(effort),
      (error) => this.handleError(error)
    );
  }

  onCreate(effort) {
    this.router.navigate(['efforts']);
  }
}



// WEBPACK FOOTER //
// ./src/app/efforts/effort-form/effort-form.component.ts